'use client';

import Image from 'next/image';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { setStoredToken } from '../../lib/auth';

const API_BASE = process.env.NEXT_PUBLIC_API_BASE || 'http://localhost:8000/api/v1';

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  async function login(e) {
    e.preventDefault();
    setMessage('Logging in...');
    try {
      const response = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      if (!response.ok) throw new Error(await response.text());
      const data = await response.json();
      setStoredToken(data.access_token);
      setMessage('Login successful.');
      router.push('/dashboard');
    } catch (error) {
      setMessage(`Login failed: ${error.message}`);
    }
  }

  return (
    <main className="login-shell">
      <section className="login-backdrop card">
        <div className="login-backdrop-art" />
        <div className="login-backdrop-copy">
          <div className="login-brand-badge">
            <span className="login-brand-badge-dot" />
            AetherPro technologies
          </div>
          <Image
            src="/brand/voiceops-wordmark.png"
            alt="VoiceOps brand icon and wordmark"
            width={900}
            height={722}
            className="login-hero-lockup"
            priority
          />
          <div className="login-brand-note">
            <span className="login-brand-note-label">VoiceOps</span>
            <span className="login-brand-note-copy">Sovereign voice operations and orchestration by AetherPro.</span>
          </div>
          <p className="login-copy">
            AI voice operations for live inbound and outbound call workflows, routing, and operator control.
          </p>
        </div>
      </section>

      <section className="login-panel card">
        <div className="login-panel-header">
          <Image
            src="/brand/favicon-192.png"
            alt="VoiceOps icon"
            width={72}
            height={72}
            className="login-mark"
          />
          <div>
            <p className="eyebrow">Secure Operator Access</p>
            <h1>Login</h1>
            <p className="login-subtitle">Sign in to manage tenants, agents, workflows, and live call operations.</p>
          </div>
        </div>

        <form onSubmit={login} className="login-form">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            autoComplete="email"
          />
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            autoComplete="current-password"
          />
          <button type="submit">Sign In</button>
        </form>

        <section className="login-status card">
          <strong>Status:</strong> {message || 'Idle'}
        </section>
      </section>
    </main>
  );
}
